import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { Input } from "../ui/input";

export const Card = ({ icon: Icon, iconClass = "text-blue-600", title, subtitle, children, testId }) => (
  <div className="bg-white border border-slate-200 rounded-sm" data-testid={testId}>
    <div className="px-6 py-4 border-b border-slate-200 flex items-center gap-2">
      <Icon className={`w-5 h-5 ${iconClass}`} />
      <div>
        <div className="text-sm font-bold text-slate-900">{title}</div>
        {subtitle && <div className="text-xs text-slate-500">{subtitle}</div>}
      </div>
    </div>
    <div className="p-6 space-y-5">{children}</div>
  </div>
);

export const FieldLabel = ({ title, hint }) => (
  <>
    <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">{title}</Label>
    {hint && <div className="text-[11px] text-slate-500 mb-1">{hint}</div>}
  </>
);

export const TextField = ({ title, hint, value, onChange, placeholder, maxLength = 80, mono, testId }) => (
  <div>
    <FieldLabel title={title} hint={hint} />
    <Input
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      maxLength={maxLength}
      className={`rounded-sm h-10 ${mono ? "font-mono" : ""}`}
      data-testid={testId}
    />
  </div>
);

export const ToggleTile = ({ title, hint, checked, onChange, testId }) => (
  <label className="flex items-center justify-between gap-3 bg-slate-50 border border-slate-200 rounded-sm px-3 py-2.5 cursor-pointer">
    <div className="min-w-0">
      <div className="text-xs font-semibold text-slate-900">{title}</div>
      {hint && <div className="text-[10px] text-slate-500">{hint}</div>}
    </div>
    <Switch checked={!!checked} onCheckedChange={onChange} data-testid={testId} />
  </label>
);

export const Segmented = ({ options, value, onChange, testIdPrefix, small }) => (
  <div className="inline-flex flex-wrap gap-1">
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        onClick={() => onChange(o.value)}
        className={`rounded-sm border-2 font-bold transition-colors ${small ? "px-2.5 py-1 text-[11px]" : "px-5 py-2 text-sm"} ${
          value === o.value ? "border-blue-600 bg-blue-50 text-blue-700" : "border-slate-200 text-slate-600 hover:border-slate-300"
        }`}
        data-testid={`${testIdPrefix}-${o.value}`}
      >
        {o.label}
      </button>
    ))}
  </div>
);
